<section class="section-container d-flex flex-column flex-md-row">
  <div class="order-1 col-12 offset-md-1 col-md-7">
    <div class="card">
      @if (ticketProducts$ | async; as groups) {
        @for (group of groups; track group.title) {
          <div class="mb-5">
            <h2 class="text-lg text-md-xl mb-4">{{ group.title }}</h2>
            @for (item of group.items; track item.product.id) {
              <div
                class="row list-item"
                [class.list-item-contained]="hasItemsWithin(item.product.id, item.supplements) | async"
              >
                <div class="col-7 col-md-8">
                  <div class="d-flex">
                    @if (item.product.image) {
                      <div class="img-thumbnail">
                        <img
                          width="56"
                          height="56"
                          [ngSrc]="item.product.image | plysResize: 56 : 56"
                          [alt]="item.product.name"
                        />
                      </div>
                    }
                    <div>
                      <h3>
                        <span class="mr-2">{{ item.product.name }}</span>
                        @if (
                          isMenuVisible(item.product, item.supplements) && showState.showMenuRedirectUrl$ | async;
                          as url
                        ) {
                          <a [href]="url" target="_blank" class="menu desktop">
                            <span class="meal-icon" inlineSVG="/assets/icons/meal.svg"></span>
                            {{ 'global.menu' | transloco }}
                          </a>
                        }
                      </h3>
                      <div>
                        <strong class="text-md pr-2">{{
                          item.product.price | localeCurrency: item.product.currency
                        }}</strong>
                        @if (item.product.priceBefore) {
                          <small class="price-discounted pr-2">{{
                            item.product.priceBefore | localeCurrency: item.product.currency
                          }}</small>
                        }
                        @if (
                          item.product.formatSurcharge && item.product.showFormatSurcharge && (formatLabel$ | async);
                          as format
                        ) {
                          <small class="format-surcharge color-label d-block">{{
                            'tickets.format_surcharge'
                              | transloco
                                : {
                                    amount: item.product.formatSurcharge | localeCurrency: item.product.currency,
                                    format: format,
                                  }
                          }}</small>
                        }
                        @for (surcharge of item.product.filmSurcharges; track $index) {
                          <small class="format-surcharge film-surcharge color-label d-block">{{
                            'tickets.film_surcharge'
                              | transloco
                                : {
                                    amount: surcharge.amount | localeCurrency: item.product.currency,
                                    name: surcharge.name,
                                  }
                          }}</small>
                        }
                        <ng-container
                          *ngTemplateOutlet="
                            productDescription;
                            context: {
                              description: item.product.description,
                              id: item.product.id,
                              extraClass: 'desktop',
                            }
                          "
                        ></ng-container>
                      </div>
                    </div>
                  </div>
                  <ng-container
                    *ngTemplateOutlet="
                      productDescription;
                      context: {
                        description: item.product.description,
                        id: item.product.id,
                        extraClass: 'mobile',
                      }
                    "
                  ></ng-container>
                </div>
                <div class="col-5 col-md-4 mt-3 quantity-control-container">
                  <!-- Nothing left and nothing taken yet: the label stands in for the counter entirely. -->
                  @if (item.availabilityState === 'sold-out') {
                    <div class="sold-out-row">
                      <ng-container *ngTemplateOutlet="mobileMenu; context: { product: item.product }"></ng-container>
                      <span class="sold-out-label">{{ 'tickets.sold_out' | transloco }}</span>
                    </div>
                  } @else {
                    <plys-quantity-control
                      [value]="getTicketQuantity(item.product.id) | async"
                      (increased)="addTicketToCart(item.product)"
                      (decreased)="removeTicketFromCart(item.product.id)"
                      [disabled]="item.availabilityState === 'full' || item.availabilityState === 'full-elsewhere'"
                      [useLoading]="true"
                      [displayLoading]="ticketCounterLoading$ | async"
                    >
                      <ng-container *ngTemplateOutlet="mobileMenu; context: { product: item.product }"></ng-container>
                      @if (item.availabilityState === 'full') {
                        <span plysQuantityNote class="full-label" data-test="full">{{
                          'tickets.full' | transloco
                        }}</span>
                      }
                    </plys-quantity-control>
                  }
                </div>
                @if (hasItemsWithin(item.product.id, item.supplements) | async) {
                  <plys-ticket-extras
                    class="col-12"
                    [product]="item.product"
                    [supplements]="item.supplements"
                    [ticket]="ticketFor(item.product)"
                  ></plys-ticket-extras>
                }
              </div>
            }
          </div>
        }
        @if (filmExtras$ | async; as filmExtras) {
          @if (filmExtras.length) {
            <div class="mb-5" data-testid="film-extras">
              <h2 class="text-lg text-md-xl mb-4">{{ 'supplements.film_extras_title' | transloco }}</h2>
              <plys-film-extras [supplements]="filmExtras"></plys-film-extras>
            </div>
          }
        }
      } @else {
        <div class="d-flex justify-content-center align-items-center m-5">
          <mat-spinner class="spinner-primary" [diameter]="30"></mat-spinner>
        </div>
      }
    </div>
  </div>
  <div class="order-0 col-12 order-md-1 col-md-3">
    <plys-movie-widget></plys-movie-widget>
    <div class="d-none d-md-block">
      <plys-cart-preview></plys-cart-preview>
    </div>
  </div>
</section>
<footer class="footer d-none d-md-flex justify-content-end">
  <div class="d-flex align-items-center footer-action-right">
    <button class="btn btn-primary btn-lg" (click)="handleContinueClick()" [disabled]="disabledButton$ | async">
      {{ 'global.continue' | transloco }}
    </button>
  </div>
</footer>
<plys-mobile-cart-footer>
  <button
    cartFooterContinue
    class="btn btn-primary btn-lg"
    (click)="handleContinueClick()"
    [disabled]="disabledButton$ | async"
  >
    {{ 'global.continue' | transloco }}
  </button>
</plys-mobile-cart-footer>
<ng-template #mobileMenu let-product="product">
  @if (isMenuVisible(product) && showState.showMenuRedirectUrl$ | async; as url) {
    <a [href]="url" target="_blank" class="menu mobile-flex">
      <span class="meal-icon" inlineSVG="/assets/icons/meal.svg"></span>
    </a>
  }
</ng-template>
<ng-template
  #productDescription
  let-description="description"
  let-id="id"
  let-childId="childId"
  let-extraClass="extraClass"
>
  @if (isExpanded(id, childId)) {
    <div class="description" [ngClass]="extraClass">
      {{ description }}
    </div>
  }
  @if (description) {
    <p class="read-details" [ngClass]="extraClass" (click)="toggleDetails(id, childId)">
      {{ 'global.read_details' | transloco }}
      <span
        [class.expanded]="isExpanded(id, childId)"
        class="read-details-icon"
        [inlineSVG]="'/assets/icons/icon-chevron-down-thick.svg'"
      ></span>
    </p>
  }
</ng-template>
